import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Router, Params, ActivatedRoute , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-account-exists',
  templateUrl: './account-exists.component.html',
  styleUrls: ['./account-exists.component.scss'],
})
export class AccountExistsComponent implements OnInit {
  email: any;
  isAcmic = false;
  userDetail: any = [];
  constructor(
    private router: Router,
    private routeParams: ActivatedRoute,
    private acmicService: AcmicService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.routeParams.queryParams.subscribe((params: Params) => {
      this.email = params['email'] || '';
    });
  }

  prefillEmailParamater(): void {
    this.router.navigate(['/forgotpassword']);
  }
}
